// W0-B (B2, B4): back-links from a run to its grower and its QC check. Each is
// offered only to a viewer the route gate admits (useCanOpenModule is null while
// deciding, which reads as plain text), and stamps the run as the return path.
import { Link } from 'react-router-dom'
import { FlaskConical } from 'lucide-react'
import { useCanOpenModule } from '@/hooks/useCanOpenModule'
import { useReturnHereState } from '@/lib/returnTo'

export function RunGrowerLink({ growerId, name }: { growerId: string | null | undefined; name: string }) {
  const canOpen = useCanOpenModule('growers') === true
  const returnHere = useReturnHereState()
  if (!growerId || !canOpen) return <span className="text-fg font-medium">{name}</span>
  return (
    <Link to={`/growers/${growerId}`} state={returnHere}
      className="text-link hover:text-blue-300 font-medium inline-flex items-center min-h-[44px]">
      {name}
    </Link>
  )
}

export function RunQcLink({ runId }: { runId: string }) {
  const canOpen = useCanOpenModule('qc') === true
  const returnHere = useReturnHereState()
  if (!canOpen) return null
  return (
    <Link to={`/qc/run/${runId}`} state={returnHere}
      className="btn-ghost btn-sm shrink-0 min-h-[44px] flex items-center gap-1">
      <FlaskConical size={14} /> QC check
    </Link>
  )
}
